import { observable, action } from "mobx";
import { httpClient } from "../../utils/httpClient";
import api from "../../config/api"
// import { formatCateTree, formatCateTable } from '../../utils/common'
const { order } = api

class OrderStore {

  // 获取订单列表
  @observable orderList = {
    list: [],
    pages: {
      total: 0,
      pageSize: 20,
      currentPage: 1
    }
  }
  @action async getOrderList(params) {
    try {
      const { data } = await httpClient.post(order.GET_ORDER_LIST, { ...params })
  
      this.orderList = {
        list: data.list,
        pages: {
          total: data.total,
          pageSize: params.pageSize,
          currentPage: data.page
        }
      }
    } catch (error) {}
  }


  // 继续下单确认
  @action async sendConfirmOrder(params) {
    try {
      const { success } = await httpClient.post(order.SEND_CONFIRM_ORDER, {...params})
      // // 后端说算了，让页面刷新吧
      // if(success) {
      //   // 更改state.orderList 以更新页面展示
      //   const _newList = this.orderList.list
      //   _newList.filter(item => item.orderNo === params.orderNo)[0].orderStatus = params.status
      //   this.orderList.list = _newList
      // }
      return success
    } catch (error) {
      return false;
    }
  }

  // 获取订单详情
  @observable orderDetail = {
    orderShopList: [],
    orderStatusList: []
  }
  @action async getOrderDetail(params) {
    try {
      const { data } = await httpClient.get(order.GET_ORDER_DETAIL, { params })
  
      this.orderDetail = {
        ...data,
        timeLineStatus: data.orderStatusList.filter(item => item.time).length
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  // 获取物流信息
  @observable logisticsInfo = {}
  @action async getLogisticsList(params) {
    try {
      const { data } = await httpClient.get(order.GET_LOGISTICS_LIST, { params })
  
      this.logisticsInfo = data
      return data
    } catch (error) {
      return false
    }
  }
  
  // 获取售后工单列表
  @action async getServiceList(params) {
    try {
      const { data } = await httpClient.post(order.GET_REFUND_LIST, { ...params })
      
      return data;
    } catch (error) {
      return false;
    }
  }

  // 获取售后工单详情
  @action async getAfterSaleDetail(params) {
    try {
      const { data } = await httpClient.get(order.GET_REFUND_DETAIL, { params })
      
      return data;
    } catch (error) {
      return false;
    }
  }

  // 新增分类
  @action updateCate(params) {
    return params.isAdd 
      ? httpClient.post(order.ADD_CATE, {...params})
      : httpClient.post(order.EDIT_CATE, {...params})
  }

  // 删除分类
  @action delCate(params) {
    return httpClient.post(order.DEL_CATE, {...params});
  }


  //----------------卡券订单-------------------//
  // 获取订单列表
  @action async getCardOrderList(params) {
    try {
      const { data } = await httpClient.post(order.GET_CARD_ORDER_LIST, { ...params })
      
      return data;
    } catch (error) {
      return false;
    }
  }

  // 获取订单详情
  @action async getCardOrderDetail(params) {
    try {
      const { data } = await httpClient.get(order.GET_CARD_ORDER_DETAIL, { params })
      
      return data;
    } catch (error) {
      return false;
    }
  }

  // 获取卡券订单-卡券详情
  @action async getOrderCardInfo(params) {
    try {
      const { data } = await httpClient.get(order.GET_ORDER_CARD_DETAIL, { params })
      
      return data;
    } catch (error) {
      return false;
    }
  }
}

export default new OrderStore();
